import React from 'react'

import TextInput from '../../../components/text-input'
import PeriodPickerComponent from '../../../components/period-picker'
import TextEditor from '../../../components/text-editor'
import Education from '../education'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import ListLevelHeader from '../../../components/utils/list-element-header'

class WorkComponent extends Education {
  render() {
    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            <ListLevelHeader
              what={this.state.model.position}
              where={this.state.model.company}
              period={this.state.model.period}
            />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="position"
                label="Job title"
                value={this.state.model.position}
                update={this.update}
              />

              <TextInput
                field="company"
                label="Company"
                value={this.state.model.company}
                update={this.update}
              />
            </div>
            <div className="section-basics-line">
              <PeriodPickerComponent
                field="period"
                model={this.state.model.period}
                updatePeriod={this.update}
              />

              <TextInput
                field="location"
                label="City"
                value={this.state.model.location}
                update={this.update}
              />
            </div>
            <div>
              <TextEditor
                field="summary"
                label="Description"
                value={this.state.model.summary}
                update={this.update}
              />
            </div>
            <div className="button-remove-element" onClick={this.removeElement}>
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

WorkComponent.defaultProperties = { open: false }
export default WorkComponent
